// extracted by mini-css-extract-plugin
module.exports = {"tag":"styles_tag__57edX","tagButton":"styles_tagButton__RsIt_","icon":"styles_icon__BXJg1","label":"styles_label__Qj09R"};